
import { ProfileDetailPanel } from "@/components/settings/profiles/Detail";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceContext } from "@/layouts/ResourceContext";
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  PlusCircleOutlined,
  ExportOutlined,
  ImportOutlined
} from "@ant-design/icons";
import { Button, Modal, Dropdown, Space, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useUpdate, useInvalidate } from "@refinedev/core";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useResourceDelete } from "@/hooks/useResourceDelete";

export const NAV_TO_PROFILE_LIST = "settings/profiles";
export const RESOURCE_TYPE_PROFILES = "profiles";

export const ProfileDetailTabs = () => {
  let tabs = [
    {
      key: "details",
      label: "Details",
      children: <ProfileDetailPanel />,
    },
  ]
  return tabs;
};

export const ProfileActions = () => {
  const { t } = useTranslation();
  const { state, dispatch, rootState } = useResourceContext();
  const navigate = useResourceNavigate();
  const invalidate = useInvalidate();
  const [selected] = state.selectedResources;

  const navigateToCreation = () => {
    navigate({ resource: NAV_TO_PROFILE_LIST, action: "create" });
  };
  const { mutateAsync: deleteMutate } = useResourceDelete();
  const { mutate, isLoading: isUpdating } = useUpdate({
    successNotification: (response, { id, values }, resource) => {
      const { action, data } = values;
      return {
        message: t(`settings.actionResult.${action}.success`, {resource:"instance profile", id }),
        description: "Success",
        type: "success",
      };
    },
  });

  const actionsMenu = [
    { key: "edit", label: (<span><EditOutlined /> {t("settings.menu.edit")}</span>), disabled: !selected },
    { key: "export", label: (<span><ExportOutlined /> {t("settings.menu.export")}</span>), disabled: !selected },
    { key: "import", label: (<span><ImportOutlined /> {t("settings.menu.import")}</span>) },
    { key: "delete", label:(<span>
      <DeleteOutlined /> {t("settings.menu.delete")}
      </span>), disabled: !selected },
  ];

  const onClickAction = (item) => {
    const [selected] = state.selectedResources;
    console.log("Action:", selected.name, item.key);
    if (item.key === "delete") {
      deleteMutate({
        resource: RESOURCE_TYPE_PROFILES,
        id: selected.name,
        successNotification: (data, values, resource) => {
          let profiles = rootState?.eks?.data["instance-profiles"]||[];
          let idx = profiles.indexOf(selected.name);
          if (idx > -1) {
            profiles.splice(idx, 1);
            dispatch({
              type: "SELECT_RESOURCE",
              payload: profiles[0],
            }); // select first one
          }
          return {
            message: t(`profiles.actionResult.delete.success`, { id:selected.name }),
            type: "success",
          };
        }
      });
    }  else if(item.key === "import") {
          navigate({
            resource: NAV_TO_PROFILE_LIST,
            action: item.key,
            key: "profile",
          });
    } else {
      navigate({
        resource: NAV_TO_PROFILE_LIST,
        action: item.key,
        key: selected.name,
      });
    }
  };

  const buttons = [
    <Dropdown
      key="action"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("settings.versions.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    
    <Button
      key="launch"
      icon={<PlusCircleOutlined />}
      onClick={navigateToCreation}
    >
      {t("settings.profiles.menu.launch")}
    </Button>,

    <RefreshButton
      key="refresh"
      onClick={() => {
        invalidate({
          resource: RESOURCE_TYPE_PROFILES,
          invalidates: ["list"],
        });
      }}
    />,
  ];
  return <Space>{buttons}</Space>;
};
